import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { Link } from "react-router-dom";
import edjsHTML from "editorjs-html";
import { NoteModel } from "../../components/dealer/profile/notes/NoteModel";
import ViewDealerTable from "../../components/dealer/ViewDealerTable";
import Header from "../../components/layout/Header";
import Loader from "../../components/layout/Loader";
import LoaderLin from "../../components/layout/LoaderLin";
import Sidebar from "../../components/layout/Sidebar";
import { objToArr } from "../../functions/general/Function";
import {
    DealerOrderStatsAction,
    UpdateDealerNotesAction,
    ViewDealerAction,
} from "../../redux/actions/DealerAction";
import { getCreditData } from "../../redux/actions/CreditSystemActions";

const ViewDealer = ({ nav }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { id } = useParams();

    const userLogin = useSelector((state) => state.userSignIn);
    const { error, userInfo } = userLogin;
    const dealerDetail = useSelector((state) => state.viewDealer);
    const { loading, dealer, success: detailSuccess } = dealerDetail;
    const orderStats = useSelector((state) => state.dealerOrderStats);
    const { loading: statsLoading, stats, success: statsSuccess } = orderStats;
    const updateNotesSubmit = useSelector((state) => state.updateDealerNotes);
    const { loading: noteLoading, success: nodesSuccess } = updateNotesSubmit;
    const {
        creditData,
        loading: creditDataLoading,
    } = useSelector((state) => state.credit);

    const [open, setOpen] = useState(false);
    const [initialNotesData, setInitialNotesData] = useState(null);

    const handleOpen = () => {
        setOpen(true);
        setInitialNotesData(dealer?.notes || null);
    };

    const handleUpdateNotes = async (newNotesData) => {
        setOpen(false);
        if (newNotesData) {
            const val = {
                dealerId: id,
                notes: newNotesData,
            };
            await dispatch(UpdateDealerNotesAction(val, userInfo.token));
            await dispatch(ViewDealerAction(id, userInfo.token));
        } else {
            console.error("New notes data is empty");
        }
    };

    const renderNotes = (notesData) => {
        console.log("renderNotes input:", notesData);
        if (!notesData) {
            console.log("No notes data provided");
            return "<p>No Notes 😎</p>";
        }
        if (typeof notesData === "string") {
            console.log("Notes is a string:", notesData);
            return `<p>${notesData.replace(/</g, "&lt;").replace(/>/g, "&gt;")}</p>`;
        }
        if (!notesData.blocks || !Array.isArray(notesData.blocks) || notesData.blocks.length === 0) {
            console.log("No valid blocks in notes:", notesData);
            return "<p>No Notes 😎</p>";
        }
        try {
            const parser = edjsHTML();
            const html = parser.parse(notesData);
            console.log("Parsed HTML:", html);
            const htmlArray = Array.isArray(html) ? html : [html];
            if (htmlArray.length === 0) {
                return "<p>No Notes 😎</p>";
            }
            return htmlArray.join("");
        } catch (error) {
            console.error("Error parsing notes:", error);
            return "<p>Error rendering notes</p>";
        }
    };

    useEffect(() => {
        if (!userInfo) {
            navigate("/sign-in");
        }
        window.scrollTo(0, 0);
        dispatch(ViewDealerAction(id, userInfo.token));
        dispatch(DealerOrderStatsAction(id, userInfo.token));
        dispatch(getCreditData(id));
    }, [id, dispatch, userInfo, navigate]);

    useEffect(() => {
        if (nodesSuccess) {
            dispatch(ViewDealerAction(id, userInfo.token));
        }
    }, [nodesSuccess, dispatch, id, userInfo.token]);

    return (
        <>
            <div className={nav.isSidebar}>
                <Header nav={nav} />
                <Sidebar nav={nav} />
                <main className="page-content">
                    {/* Rest of the component remains unchanged */}
                    <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                        <div className="breadcrumb-title pe-3">Dashboard</div>
                        <div className="ps-3">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/">
                                            <i className="bx bx-home-alt" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/dealer/list-dealer">List All Dealers</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        View Dealer
                                    </li>
                                </ol>
                            </nav>
                        </div>
                        <div className="ms-auto">
                            <div className="btn-group">
                                <button
                                    type="button"
                                    className="btn btn-light"
                                    data-bs-toggle="dropdown"
                                >
                                    Edit Dealer Details
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-light split-bg-light dropdown-toggle dropdown-toggle-split"
                                    data-bs-toggle="dropdown"
                                >
                                    <span className="visually-hidden">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu dropdown-menu-right dropdown-menu-lg-end">
                                    <Link className="dropdown-item text-light" to={`/dealer/edit-profile/${id}`}>
                                        Edit Dealer
                                    </Link>
                                    <Link className="dropdown-item text-light" to={`/dealer/edit-product-rate/${id}`}>
                                        Edit Product Rate
                                    </Link>
                                    <Link className="dropdown-item text-light" to={`/dealer/edit-material-rate/${id}`}>
                                        Edit Material price
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    {loading ? (
                        <Loader />
                    ) : (
                        <NoteModel
                            open={open}
                            setOpen={setOpen}
                            initialNotesData={initialNotesData}
                            handleUpdateNotes={handleUpdateNotes}
                        />
                    )}
                    <ViewDealerTable d={{ dealer, detailSuccess, stats, statsSuccess, creditData }} />
                    <h6 className="mb-0 text-uppercase">Dealer Action Section</h6>
                    <hr />
                    <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-xl-4 row-cols-xxl-4">
                        <div className="col">
                            <div className="card-body">
                                <div className="d-flex justify-content-center mt-3">
                                    <Link to={`/dealer/transactions/${id}`}>
                                        <button
                                            type="button"
                                            className="btn btn-lg btn-info px-5 radius-30 btn-block"
                                        >
                                            <i className="fadeIn animated bx bx-dollar-circle" />
                                            Transaction History
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card-body">
                                <div className="d-flex justify-content-center mt-3">
                                    <Link to={`/dealer/account-view/${id}`}>
                                        <button
                                            type="button"
                                            className="btn btn-lg btn-info px-5 radius-30"
                                        >
                                            <i className="fadeIn animated bx bx-coin-stack" />
                                            Accounts Management
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card-body">
                                <div className="d-flex justify-content-center mt-3 mb-4">
                                    {loading ? (
                                        <LoaderLin />
                                    ) : (
                                        <button
                                            type="button"
                                            className="btn btn-lg btn-info px-5 radius-30"
                                            onClick={handleOpen}
                                        >
                                            <i className="fadeIn animated bx bx-notepad" />
                                            Dealer Notes / Remarks
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card-body">
                                <div className="d-flex justify-content-center mt-3">
                                    <Link to={`/dealer/credit-system/${id}`}>
                                        <button
                                            type="button"
                                            className="btn btn-lg btn-warning px-5 radius-30 btn-block shadow"
                                            style={{
                                                background: "linear-gradient(45deg, #ffcc00, #ff9900)",
                                                color: "#fff",
                                            }}
                                        >
                                            <i className="fadeIn animated bx bx-wallet" />
                                            Credit System
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h6 className="mb-0 text-uppercase">Dealer Overview</h6>
                    <hr />
                    <div className="card radius-10">
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-12 col-lg-4 col-xl-4 d-flex">
                                    <div className="card mb-0 radius-10 border shadow-none w-100">
                                        <div className="card-body">
                                            <div className="d-flex justify-content-between align-items-center">
                                                <h5 className="card-title">
                                                    <i className="fadeIn animated bx bx-dollar" />
                                                    Products rates
                                                </h5>
                                                <Link
                                                    className="btn btn-sm btn-primary"
                                                    to={`/dealer/edit-product-rate/${id}`}
                                                >
                                                    Edit Product Rate
                                                </Link>
                                            </div>
                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <>
                                                    <p className="mb-0 text-secondary font-13">
                                                        These are the current product rates. To edit/update
                                                        the rates go to Dealer Product rate management
                                                    </p>
                                                    <ul className="list-group list-group-flush mt-3">
                                                        {dealer &&
                                                            objToArr(dealer.productRate).map((arr) => (
                                                                <li className="list-group-item border-top" key={arr[0]}>
                                                                    <div className="d-flex align-items-center gap-2">
                                                                        <div>
                                                                            <i className="fadeIn animated bx bx-caret-right" />
                                                                        </div>
                                                                        <div>{arr[0]}</div>
                                                                        <div className="ms-auto">
                                                                            $ <b>{arr[1]}</b> / SQFT
                                                                        </div>
                                                                    </div>
                                                                </li>
                                                            ))}
                                                    </ul>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-8 col-xl-8 d-flex">
                                    <div className="card mb-0 radius-10 border shadow-none w-100">
                                        <div className="card-body">
                                            <h5 className="card-title">
                                                <i className="fadeIn animated bx bx-notepad" /> Notes/Remarks
                                            </h5>
                                            {loading ? (
                                                <Loader />
                                            ) : (
                                                <div
                                                    className="mb-0 text-secondary"
                                                    dangerouslySetInnerHTML={{ __html: renderNotes(dealer?.notes) }}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <div className="overlay nav-toggle-icon" />
                <a href="" className="back-to-top">
                    <i className="bx bxs-up-arrow-alt" />
                </a>
            </div>
        </>
    );
};

export default ViewDealer;